import { useEffect, useRef } from 'react';
import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect';
export function useInterval(callback, delay) {
    const savedCallback = useRef(callback);
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        if (delay === null) {
            return;
        }
        const id = setInterval(() => {
            savedCallback.current();
        }, delay);
        return () => {
            clearInterval(id);
        };
    }, [delay]);
}
